import Api from "~/service/Api";

class TourJobFileRepository {
  fetch(query = {}) {
    return Api.get("/tour/job/files", query);
  }

  getDownloadUrl(tourJobFileId) {
    return `/api/tour/job/file/download/${tourJobFileId}`;
  }
}

export default TourJobFileRepository;
